<ng-container *t="let t">
    <!-- add tire inventory -->
    <div class="right" style="padding-bottom: 15px;">
        <!-- todo ttp -->
        <button
            tsl-button
            size="small"
            color="black"
            outline
            *ngIf="inventoryList && inventoryList.length > 0"
            (click)="showHistory()"
            i18n="@@2919237623258423230" t="2919237623258423230"
            tooltip="Show History" i18n-tooltip="@@2279638681844186468" #historyButton tslTooltip="{{ t('2279638681844186468', historyButton) }}"
        >
            History
        </button>
        <!-- todo ttp -->
        <button
            tsl-button
            size="small"
            color="blue"
            (click)="openForm(null)"
            i18n="@@71641abe42893a23a500a4dbf647735c066fa1a7" t="71641abe42893a23a500a4dbf647735c066fa1a7"
            tooltip="Add to Inventory" i18n-tooltip="@@334614164807800006" #addToInventoryButton tslTooltip="{{ t('334614164807800006', addToInventoryButton) }}"
        >
            Add Tire Inventory
        </button>
    </div>

    <!-- grid start -->
    <table tsl-table [dataSource]="datasource">
        <!-- Location Column -->
        <ng-container tslColumnDef="location">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@ed31c09fd77c36238c13d83635f3fe5294c733d2"
                t="ed31c09fd77c36238c13d83635f3fe5294c733d2"
            >
                Location
            </th>
            <td tsl-cell *tslCellDef="let row"></td>
        </ng-container>

        <!-- Model Column -->
        <ng-container tslColumnDef="model">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@6ec98fa3d6504ba1fd03465194b53706c8263c99"
                t="6ec98fa3d6504ba1fd03465194b53706c8263c99"
            >
                Model
            </th>
            <td tsl-cell *tslCellDef="let row">{{ getModelName(row.modelTypeId) }}</td>
        </ng-container>

        <!-- Tire Size Column -->
        <ng-container tslColumnDef="tiresize">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@3ad1d838b44d79edfc181316fa94c26ad69e97de"
                t="3ad1d838b44d79edfc181316fa94c26ad69e97de"
            >
                Tire Size
            </th>
            <td tsl-cell *tslCellDef="let row">{{ getTireSize(row.tireSizeId) }}</td>
        </ng-container>

        <!-- Quantity Column -->
        <ng-container tslColumnDef="quantity">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@ca30c1aa79fb5ab487fbd2caa4ca01f2f6691d70"
                t="ca30c1aa79fb5ab487fbd2caa4ca01f2f6691d70"
                >Quantity</th
            >
            <td tsl-cell *tslCellDef="let row">{{ row.quantity }}</td>
        </ng-container>

        <!-- Action Column -->
        <ng-container tslColumnDef="actions">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@28f86ffd419b869711aa13f5e5ff54be6d70731c"
                t="28f86ffd419b869711aa13f5e5ff54be6d70731c"
            >
                Edit
            </th>
            <td tsl-cell *tslCellDef="let row">
                <button tsl-icon-button (click)="openForm(row)">
                    <tsl-icon status="primary">edit</tsl-icon>
                </button>
            </td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>

        <!-- Group header -->
        <ng-container tslColumnDef="groupHeader">
            <td colspan="5" tsl-cell *tslCellDef="let group">
                <strong class="group-header">{{ translateService.get(group.name) }}</strong>
            </td>
        </ng-container>
        <tr tsl-row *tslRowDef="let row; columns: ['groupHeader']; when: isHeader"></tr>
    </table>

    <!-- grid pagination -->
    <tsl-pagination
        showFirstLastButtons
        [pageSizeOptions]="pageSizeOptions"
        [total]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (pageChange)="onPageChange($event)"
        [itemsPerPageLabel]="translateService.get('ItemsPerPage')"
    >
    </tsl-pagination>
</ng-container>
